// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__jsaeH","blue_nav":"Header_blue_nav__cXO5a","nav_link":"Header_nav_link__14j6p","white_nav":"Header_white_nav__X_vS0","sign_up":"Header_sign_up__3RJjs"};